"use strict";
/*
 * Created on 29. 4. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Encapsulates short info about {@link Supplier supplier entity}.
 * @author Radek Beran
 */


var SupplierName =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SupplierName, _DomainObject_1$Domai);

  function SupplierName(id, externalId, name) {
    var _this;

    _classCallCheck(this, SupplierName);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierName).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    return _this;
  }

  return SupplierName;
}(DomainObject_1.DomainObject);

exports.SupplierName = SupplierName;